import React from "react";

export const activeServiceWorkStatusValues = ["work", "planned", "approval", "on_approval"];

export const serviceWorkStatusLabels = {
    on_approval: "Ожидает согласования",
    approval: "На согласовании",
    planned: "Запланировано",
    work: "В работе",
};

export const getServiceWorkStatusValue = (serviceWork) => {
    const status = serviceWork?.status;

    if (!status) {
        return undefined;
    }

    if (typeof status === "string") {
        return status;
    }

    return status.code ?? status.value ?? status.id ?? status.name;
};

export const getServiceWorkStatusLabel = (serviceWork) => {
    const status = serviceWork?.status;
    const value = getServiceWorkStatusValue(serviceWork);

    if (status && typeof status === "object") {
        return status.displayName ?? status.label ?? status.name ?? serviceWorkStatusLabels[value] ?? value;
    }

    return serviceWorkStatusLabels[value] ?? value ?? "";
};

export const getServiceWorkType = (serviceWork) => {
    const type = serviceWork?.type;

    if (!type) {
        return "";
    }

    if (typeof type === "string") {
        return type;
    }

    return type.displayName ?? type.name ?? type.label ?? "";
};

export const getServiceWorkNumber = (serviceWork) =>
    serviceWork?.number ?? serviceWork?.serviceWorkNumber ?? serviceWork?.serviceWorkId ?? serviceWork?.id ?? "";

export const getServiceWorkResponsible = (serviceWork) => {
    const responsible = serviceWork?.responsible ?? serviceWork?.contractor;

    if (!responsible) {
        return "";
    }

    if (typeof responsible === "string") {
        return responsible;
    }

    return responsible.displayName ?? responsible.name ?? responsible.fullName ?? "";
};

export const getServiceWorkAddresses = (serviceWork) => {
    const addresses =
        serviceWork?.plannedAddresses ??
        serviceWork?.addresses ??
        (serviceWork?.selectedAddress ? [serviceWork.selectedAddress] : []);

    return addresses.map((item) => (typeof item === "string" ? item : (item?.address ?? item?.name))).filter(Boolean);
};

export const getServiceWorkAddressText = (serviceWork) => {
    const selectedAddress = serviceWork?.selectedAddress;

    if (selectedAddress) {
        return typeof selectedAddress === "string"
            ? selectedAddress
            : (selectedAddress.address ?? selectedAddress.name ?? "");
    }

    return (
        <ol className="pl-4">
            {getServiceWorkAddresses(serviceWork).map((item, i) => (
                <li key={i}>{item}</li>
            ))}
        </ol>
    );
};

export const serviceWorkHasActiveStatus = (serviceWork) => {
    const statusValue = getServiceWorkStatusValue(serviceWork);

    return !statusValue || activeServiceWorkStatusValues.includes(statusValue);
};

export const ServiceWorkStatusRow = ({ serviceWork, labelClassName = "pr-2" }) => {
    const statusLabel = getServiceWorkStatusLabel(serviceWork);

    if (!statusLabel) {
        return null;
    }

    return (
        <div>
            <strong className={labelClassName}>Статус СР:</strong>
            <span>{statusLabel}</span>
        </div>
    );
};
